import React from 'react';
import ReactDOM from 'react-dom/client';
import { EmbedApp } from './EmbedApp';
import { WidgetConfig } from './types';
import './styles.css';

/**
 * TROIA Widget - Initialization
 *
 * Reads config from window.troiaWidgetConfig and renders the widget
 */
const initWidget = () => {
  // Get configuration from global scope
  const config: WidgetConfig | undefined = window.troiaWidgetConfig;

  if (!config) {
    console.error('❌ [TROIA Widget] Configuration not found. Please define window.troiaWidgetConfig');
    return;
  }

  // Validate required fields
  if (!config.channelId || !config.token || !config.socketUrl) {
    console.error('❌ [TROIA Widget] Missing required configuration fields');
    return;
  }

  // Create root container if doesn't exist
  let rootContainer = document.getElementById('troia-widget-root');

  if (!rootContainer) {
    rootContainer = document.createElement('div');
    rootContainer.id = 'troia-widget-root';
    document.body.appendChild(rootContainer);
  }

  // Render widget
  ReactDOM.createRoot(rootContainer).render(
    <React.StrictMode>
      <EmbedApp config={config} />
    </React.StrictMode>
  );

  console.log('✅ [TROIA Widget] Initialized successfully');
};

// Auto-initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initWidget);
} else {
  initWidget();
}
